// extracted by mini-css-extract-plugin
export default {"paymentSection":"H7-z","disabled":"I7-z"};